import React, { useState, useEffect, useRef, useCallback } from 'react';
import LayerInfo from "components/UploadPage/LeftSidebar/Layers/LayerInfo";
import SaveConfirm from "components/UploadPage/LeftSidebar/Layers/SaveConfirm";
import DeleteConfirm from "components/UploadPage/LeftSidebar/Layers/DeleteConfirm";
import MenuDrawer from "components/UploadPage/LeftSidebar/Layers/MenuDrawer";
import Box from "@mui/material/Box";
import LayerIcon from "assets/images/layer-icon.png";
import LayersDeleteIcon from "assets/images/layers-delete-icon.png";
import LayersInfoIcon from "assets/images/layers-info-icon.png";
import LayerActiveIcon from "components/UploadPage/LeftSidebar/Layers/WaveIcon";
import useUploadContext from 'hooks/useUploadContext';
import TinyGesture from 'tinygesture';
import { getItem } from "lib/Storage";
import "./index.scss";

const Layers = () => {
  const {
    layers,
    setLayers,
    selectedLayer,
    setSelectedLayer,
    mutes,
    setLayersUpdated,
    setTotalTime,
    layersUpdated,
    handleResetProject,
    layersIsActive,
    setRightTab,
    leftTab,
    setLeftTab,
    loading,
    play,
  } = useUploadContext();

  const refArr = useRef([]);
  const containerBox = useRef(null);
  const [animStates, setAnimStates] = useState([]);
  const [status, setStatus] = useState(null);

  const initSlider = useCallback((target) => {
    let swiped = 0;
    let oldSwiped = 0;
    const revealWidth = 60;

    const gesture = new TinyGesture(target);
    const layerIndex = parseInt(target.id);

    const resetPan = () => {
      const layerBoxRefs = refArr.current?.filter((_, i) => (layers[i]?.file));
      const layerBoxes = layerBoxRefs.map((layerRef) => (layerRef.layerBox));
      layerBoxes.forEach((layerBox) => {
        if (layerBox) {
          window.cancelAnimationFrame(gesture.animationFrame);
          gesture.animationFrame = null;
          window.requestAnimationFrame(() => {
            layerBox.style.transform = null;
          });
        }
      });
    };

    const handlePanStart = () => {
      resetPan();
      setSelectedLayer(layerIndex);
    };

    const handlePanMove = () => {
      if (gesture.animationFrame) return;
      gesture.animationFrame = window.requestAnimationFrame(() => {
          const newX = gesture.touchMoveX;
          target.style.transform = "translateX(" + newX + "px)";
          swiped = newX < 0 ? -revealWidth : newX > 0  ? revealWidth : 0;
      });
    };

    const handlePanEnd = () => {
      window.requestAnimationFrame(() => {
        target.style.transition = "transform .2s ease-in";
          if (swiped) {                       
              if(Math.abs(oldSwiped) > 0) {
                  target.style.transform = null;
                  oldSwiped = 0;
                  swiped = 0;
              } else {
                  target.style.transform = "translateX(" + swiped + "px)";
                  oldSwiped = swiped;
              }
          } else {
              setLeftTab('draftInfo');
          }
      });
    };

    const handleMouseleave = () => {
      window.cancelAnimationFrame(gesture.animationFrame);
      gesture.animationFrame = null;
    };

    const handleClickOutside = (event) => {
      if (!target.contains(event.target)) {
        resetPan();
      }
    };

    gesture.on("panmove", handlePanMove);
    gesture.on("panend", handlePanEnd);
    gesture.on("panstart", handlePanStart);
    target.addEventListener("mouseleave", handleMouseleave);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      target.removeEventListener("mouseleave", handleMouseleave);
    };

  }, [layers, setSelectedLayer, setLeftTab]);

  useEffect(() => {
    const layerBoxRefs = refArr.current?.filter((_, i) => (layers[i]?.file));
    const layerBoxes = layerBoxRefs.map((layerRef) => (layerRef.layerBox));
    layerBoxes.forEach((layerBox) => initSlider(layerBox));
  }, [layersUpdated, refArr, selectedLayer, initSlider, layers]);

  useEffect(() => {
    const newAnimStates = layers.map((_, i) => {
      const container = refArr.current[i]?.container;
      const content = refArr.current[i]?.content;
      return container && content && content.scrollWidth > container.offsetWidth;
    });
    setAnimStates(newAnimStates);
  }, [layers, selectedLayer]);

  const deleteLayer = () => {
    const newLayers = [...layers];
    newLayers[selectedLayer] = null;
    setLayers(newLayers);

    let maxTime = 0;
    newLayers.forEach(layer => {
      if (layer && layer.length > maxTime) {
        maxTime = layer.length;
      }
    });

    setTotalTime(maxTime);
    setLayersUpdated(true);
    setLeftTab('layers');
  };

  const handleCancel = () => {
    setLayersUpdated(true);
    setLeftTab('layers');
  };

  const handleCloseTimeline = () => {
    if (status === 'create') {
      handleResetProject();
      setLeftTab('layers');
    } else {
      const source = getItem('source');
      if(source) {
        window.location.replace(source)
      }
    }
  };

  const handleMenuInput = (i) => {
    setStatus(i);
    if (layersIsActive) {
      setLeftTab('layerSaveConfirm');
    } else {
      handleCloseTimeline();
    }
  };

  const handleSaveDraft = () => {
    setRightTab('saveDraft');
    setLeftTab('layers');
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setLeftTab('layerDeleteConfirm');
  };

  const handleInfo = (e) => {
    e.preventDefault();
    setLeftTab('layerInfo');
  };

  return (
    <Box className="layers-box-component" ref={containerBox}>
      <Box className="layers-bar-box">
        <MenuDrawer onInput={handleMenuInput} loading={loading} />
      </Box>
      <Box className="layers-list-box">
        {
            leftTab === 'layerInfo' ? (
            <LayerInfo
              data={layers[selectedLayer]}
              onClose={handleCancel}
            />
          ) : leftTab === 'layerDeleteConfirm' ? (
            <DeleteConfirm
              data={layers[selectedLayer]}
              deleteLayer={deleteLayer}
              cancel={handleCancel}
            />


          ) : leftTab === 'layerSaveConfirm' ? (
            <SaveConfirm
              onSave={handleSaveDraft}
              onClose={handleCloseTimeline}
            />
          ) : leftTab === 'layers' ? layers.map((layer, i) => (
                <Box
                  key={i}
                  id={i}
                  className={`layer-box ${selectedLayer === i ? 'active' : ''}`}
                  ref={(el) => (refArr.current[i] = { ...refArr.current[i], layerBox: el })}
                >
                  <Box className="info-icon" onClick={handleInfo}>
                    <img
                      src={LayersInfoIcon}
                      alt="layer info icon"
                    />
                  </Box>
                  <Box className="layer-title-box">
                    <Box
                      className="title"
                      ref={(el) => (refArr.current[i] = { ...refArr.current[i], container: el })}
                    >
                      <div
                        className={`${animStates[i] ? 'animate' : ''} ${layer?.file ? 'active' : ''}`}
                        ref={(el) => (refArr.current[i] = { ...refArr.current[i], content: el })}
                      >
                        {layer?.title ? layer.title : `layer ${i + 1}`}
                      </div>
                    </Box>
                    <Box className="wave-icon">
                      {layer?.file ? (
                        <LayerActiveIcon active={!mutes[i] && play} />
                      ) : (
                        <img src={LayerIcon} alt="layer icon" />
                      )}
                    </Box>
                  </Box>
                  <Box className="delete-icon" onClick={handleDelete}>
                    <img
                      src={LayersDeleteIcon}
                      alt="layer delete icon"
                    />
                  </Box>
                </Box>
              ))
            : null
        }
      </Box>
    </Box>
  );
};

export default Layers;
